import { EActionType } from '../repositories/favorites/entities/extended_data/ExtendedDataSchema';

export const showDailyrentActionButton = (
  isDailyrentOnlineBookingEnabled: boolean,
  actionType: EActionType | undefined,
) => {
  if (!actionType) {
    return {
      showOtaCheckDatesButton: false,
      showPartnerCheckDatesButton: false,
      hideActionButton: false,
    };
  }

  const showOtaCheckDatesButton =
    isDailyrentOnlineBookingEnabled && [EActionType.OtaCheckDates, EActionType.OtaBooking].includes(actionType);

  const showPartnerCheckDatesButton = [EActionType.PartnerCheckDates, EActionType.PartnerBooking].includes(actionType);

  const hideActionButton = actionType === EActionType.Chat;

  return {
    showOtaCheckDatesButton,
    showPartnerCheckDatesButton,
    hideActionButton,
  };
};
